// Generated by purs version 0.15.16
import * as Bound from "../Bound/index.js";
import * as Bounded from "../Bounded/index.js";
import * as CEK from "../CEK/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Comonad from "../Control.Comonad/index.js";
import * as Control_Monad_State_Class from "../Control.Monad.State.Class/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Class_Console from "../Effect.Class.Console/index.js";
import * as Eval from "../Eval/index.js";
import * as Expr from "../Expr/index.js";
import * as Halogen_Aff_Util from "../Halogen.Aff.Util/index.js";
import * as Halogen_Component from "../Halogen.Component/index.js";
import * as Halogen_HTML from "../Halogen.HTML/index.js";
import * as Halogen_HTML_Core from "../Halogen.HTML.Core/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_HTML_Events from "../Halogen.HTML.Events/index.js";
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
import * as Halogen_Query_HalogenM from "../Halogen.Query.HalogenM/index.js";
import * as Halogen_VDom_Driver from "../Halogen.VDom.Driver/index.js";
import * as Test_QuickCheck_Gen from "../Test.QuickCheck.Gen/index.js";
import * as Token from "../Token/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var bind = /* #__PURE__ */ Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM);
var generator = /* #__PURE__ */ Expr.generator(Test_QuickCheck_Gen.monadRecGen)(Test_QuickCheck_Gen.monadGenGen);
var pure = /* #__PURE__ */ Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM);
var extract = /* #__PURE__ */ Control_Comonad.extract(Data_Identity.comonadIdentity);
var prop = /* #__PURE__ */ Halogen_HTML_Properties.prop(Halogen_HTML_Core.isPropString);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var map1 = /* #__PURE__ */ Data_Functor.map(Halogen_Query_HalogenM.functorHalogenM);
var join = /* #__PURE__ */ Control_Bind.join(Data_Maybe.bindMaybe);
var query = /* #__PURE__ */ Halogen_Query_HalogenM.query();
var tokenizerIsSymbol = {
    reflectSymbol: function () {
        return "tokenizer";
    }
};
var query1 = /* #__PURE__ */ query(tokenizerIsSymbol)(Data_Ord.ordUnit);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var discard1 = /* #__PURE__ */ discard(Halogen_Query_HalogenM.bindHalogenM);
var parserIsSymbol = {
    reflectSymbol: function () {
        return "parser";
    }
};
var query2 = /* #__PURE__ */ query(parserIsSymbol)(Data_Ord.ordUnit);
var cekMachineIsSymbol = {
    reflectSymbol: function () {
        return "cekMachine";
    }
};
var query3 = /* #__PURE__ */ query(cekMachineIsSymbol)(Data_Ord.ordUnit);
var boundsCheckerIsSymbol = {
    reflectSymbol: function () {
        return "boundsChecker";
    }
};
var query4 = /* #__PURE__ */ query(boundsCheckerIsSymbol)(Data_Ord.ordUnit);
var closed = /* #__PURE__ */ Bound.closed(Bounded.traversableBExpr);
var $$void = /* #__PURE__ */ Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM);
var stepperIsSymbol = {
    reflectSymbol: function () {
        return "stepper";
    }
};
var query5 = /* #__PURE__ */ query(stepperIsSymbol)(Data_Ord.ordUnit);
var put = /* #__PURE__ */ Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM);
var slot = /* #__PURE__ */ Halogen_HTML.slot()({
    reflectSymbol: function () {
        return "randomExpr";
    }
})(Data_Ord.ordUnit);
var slot_ = /* #__PURE__ */ Halogen_HTML.slot_();
var slot_1 = /* #__PURE__ */ slot_(tokenizerIsSymbol)(Data_Ord.ordUnit);
var slot_2 = /* #__PURE__ */ slot_(parserIsSymbol)(Data_Ord.ordUnit);
var slot_3 = /* #__PURE__ */ slot_(cekMachineIsSymbol)(Data_Ord.ordUnit);
var slot_4 = /* #__PURE__ */ slot_(boundsCheckerIsSymbol)(Data_Ord.ordUnit);
var slot_5 = /* #__PURE__ */ slot_(stepperIsSymbol)(Data_Ord.ordUnit);
var discard2 = /* #__PURE__ */ discard(Effect_Aff.bindAff);
var log = /* #__PURE__ */ Effect_Class_Console.log(Effect_Aff.monadEffectAff);
var MkStandardTerm = function (x) {
    return x;
};
var standardTerms = /* #__PURE__ */ map(MkStandardTerm)([ {
    name: "I",
    value: "\\x.x"
}, {
    name: "S",
    value: "\\x.\\y.\\z.x z (y z)"
}, {
    name: "K",
    value: "\\x.\\y.x"
}, {
    name: "B",
    value: "\\x.\\y.\\z.x (y z)"
}, {
    name: "C",
    value: "\\x.\\y.\\z.x z y"
}, {
    name: "W",
    value: "\\x.\\y.x y y"
}, {
    name: "omega",
    value: "\\x.x x"
}, {
    name: "Omega",
    value: "(\\x.x x)\\x.x x"
}, {
    name: "T",
    value: "\\x.\\y.x"
}, {
    name: "F",
    value: "\\x.\\y.y"
} ]);
var randomExprComponent = function (dictMonadEffect) {
    var liftEffect = Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadEffect));
    var render = function (_unit) {
        return Halogen_HTML_Elements.button([ Halogen_HTML_Events.onClick(Data_Function["const"](Data_Unit.unit)) ])([ Halogen_HTML_Core.text("Random Expression") ]);
    };
    var handleAction = function (_unit) {
        return bind(liftEffect(Test_QuickCheck_Gen.randomSampleOne(generator)))(function (expr) {
            return Halogen_Query_HalogenM.raise(expr);
        });
    };
    return Halogen_Component.mkComponent({
        initialState: Data_Function["const"](Data_Unit.unit),
        render: render,
        "eval": Halogen_Component.mkEval({
            initialize: Data_Maybe.Nothing.value,
            receive: Data_Function["const"](Data_Maybe.Nothing.value),
            handleAction: handleAction,
            handleQuery: function ($62) {
                return pure(Data_Maybe.Just.create(extract($62)));
            },
            finalize: Data_Maybe.Nothing.value
        })
    });
};
var randomExprComponent1 = /* #__PURE__ */ randomExprComponent(Effect_Aff.monadEffectAff);
var inputTA = function (val) {
    return Halogen_HTML_Elements.textarea([ prop("value")(val), Halogen_HTML_Events.onValueInput(identity) ]);
};
var buttonStandardTerm = function (v) {
    return Halogen_HTML_Elements.button([ Halogen_HTML_Events.onClick(Data_Function["const"](v.value)) ])([ Halogen_HTML_Core.text(v.name) ]);
};
var aslTokenizer = /* #__PURE__ */ (function () {
    return Type_Proxy["Proxy"].value;
})();
var aslStepper = /* #__PURE__ */ (function () {
    return Type_Proxy["Proxy"].value;
})();
var aslRandomExpr = /* #__PURE__ */ (function () {
    return Type_Proxy["Proxy"].value;
})();
var aslParser = /* #__PURE__ */ (function () {
    return Type_Proxy["Proxy"].value;
})();
var aslCekMachine = /* #__PURE__ */ (function () {
    return Type_Proxy["Proxy"].value;
})();
var aslBoundsChecker = /* #__PURE__ */ (function () {
    return Type_Proxy["Proxy"].value;
})();
var evalApp = /* #__PURE__ */ (function () {
    var handleAction = function (str) {
        return bind(map1(join)(query1(aslTokenizer)(Data_Unit.unit)(new Token.Tokenize(str, Data_Maybe.Just.create, Data_Function["const"](Data_Maybe.Nothing.value)))))(function (mToks) {
            return discard1((function () {
                if (mToks instanceof Data_Maybe.Nothing) {
                    return pure(Data_Unit.unit);
                };
                if (mToks instanceof Data_Maybe.Just) {
                    return bind(query2(aslParser)(Data_Unit.unit)(new Expr.Parse(mToks.value0, identity)))(function (mExpr) {
                        if (mExpr instanceof Data_Maybe.Nothing) {
                            return pure(Data_Unit.unit);
                        };
                        if (mExpr instanceof Data_Maybe.Just) {
                            return bind(query3(aslCekMachine)(Data_Unit.unit)(mExpr.value0))(function () {
                                return bind(map1(join)(query4(aslBoundsChecker)(Data_Unit.unit)(new Bounded.BoundsCheck(mExpr.value0, closed))))(function (bexpr) {
                                    if (bexpr instanceof Data_Maybe.Nothing) {
                                        return pure(Data_Unit.unit);
                                    };
                                    if (bexpr instanceof Data_Maybe.Just) {
                                        return $$void(query5(aslStepper)(Data_Unit.unit)(bexpr.value0));
                                    };
                                    throw new Error("Failed pattern match at Main (line 201, column 13 - line 203, column 72): " + [ bexpr.constructor.name ]);
                                });
                            });
                        };
                        throw new Error("Failed pattern match at Main (line 196, column 9 - line 203, column 72): " + [ mExpr.constructor.name ]);
                    });
                };
                throw new Error("Failed pattern match at Main (line 192, column 5 - line 203, column 72): " + [ mToks.constructor.name ]);
            })())(function () {
                return put(str);
            });
        });
    };
    return Halogen_Component.mkEval({
        finalize: Data_Maybe.Nothing.value,
        receive: Data_Function["const"](Data_Maybe.Nothing.value),
        handleAction: handleAction,
        handleQuery: Data_Function["const"](pure(Data_Maybe.Nothing.value)),
        initialize: Data_Maybe.Nothing.value
    });
})();
var renderApp = function (val) {
    return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.id("app") ])([ Halogen_HTML_Elements.h2_([ Halogen_HTML_Core.text("Input Program / Source Text") ]), Halogen_HTML_Elements.p_([ Halogen_HTML_Core.text("Enter lambda expression directly") ]), Halogen_HTML_Elements.div_([ inputTA(val) ]), Halogen_HTML_Elements.p_([ Halogen_HTML_Core.text("Or, select from some "), Halogen_HTML_Elements.a([ Halogen_HTML_Properties.href("https://en.wikipedia.org/wiki/Lambda_calculus#Standard_terms") ])([ Halogen_HTML_Core.text("standard terms") ]), Halogen_HTML_Core.text(".") ]), Halogen_HTML_Elements.div_(map(buttonStandardTerm)(standardTerms)), Halogen_HTML_Elements.div_([ slot(aslRandomExpr)(Data_Unit.unit)(randomExprComponent1)(Data_Unit.unit)(Expr.print) ]), Halogen_HTML_Elements.h2_([ Halogen_HTML_Core.text("Static Analysis / Compilation") ]), Halogen_HTML_Elements.h3_([ Halogen_HTML_Core.text("Tokenization") ]), Halogen_HTML_Elements.p_([ Halogen_HTML_Core.text("Fundamentally, tokenization takes an external input stream (usually bytes / octets)"), Halogen_HTML_Core.text(" and converts to a stream with elements (\"tokens\") suitable for input to the parser."), Halogen_HTML_Core.text("  Tokenization is reset anytime the input changes.") ]), slot_1(aslTokenizer)(Data_Unit.unit)(Token.tokenizer)(Data_Unit.unit), Halogen_HTML_Elements.h3_([ Halogen_HTML_Core.text("Parsing") ]), Halogen_HTML_Elements.p_([ Halogen_HTML_Core.text("Parsing takes a stream and discovers / applies a tree struture to generate an abstract syntax tree (AST)."), Halogen_HTML_Core.text("  Parsing is reset on successful tokenization.") ]), slot_2(aslParser)(Data_Unit.unit)(Expr.parserComponent)(Data_Unit.unit), Halogen_HTML_Elements.h3_([ Halogen_HTML_Core.text("CEK Machine evaluation") ]), slot_3(aslCekMachine)(Data_Unit.unit)(CEK.component)(Data_Unit.unit), Halogen_HTML_Elements.h3_([ Halogen_HTML_Core.text("Scope Checking / Nameless Represenation") ]), Halogen_HTML_Elements.p_([ Halogen_HTML_Core.text("In this implementation we convert references to a nameless representation using"), Halogen_HTML_Core.text(" (generalized) DeBruijn indexes.  Out-of-scope varible references are highlighted."), Halogen_HTML_Core.text("  If the are any, scope checking has failed.") ]), slot_4(aslBoundsChecker)(Data_Unit.unit)(Bounded.boundsChecker)(Data_Unit.unit), Halogen_HTML_Elements.h2_([ Halogen_HTML_Core.text("Evaluation") ]), Halogen_HTML_Elements.p_([ Halogen_HTML_Core.text("Evaluation is reset when the static analysis successfully changes."), Halogen_HTML_Core.text("  The next small step in evaluation is named, clicking that step name will advance.") ]), slot_5(aslStepper)(Data_Unit.unit)(Eval.stepper)(Data_Unit.unit) ]);
};
var app = /* #__PURE__ */ Halogen_Component.mkComponent({
    initialState: /* #__PURE__ */ Data_Function["const"](""),
    render: renderApp,
    "eval": evalApp
});
var main = /* #__PURE__ */ Halogen_Aff_Util.runHalogenAff(/* #__PURE__ */ Control_Bind.bind(Effect_Aff.bindAff)(Halogen_Aff_Util.awaitBody)(function (body) {
    return discard2(log("Ready to runUI"))(function () {
        return Halogen_VDom_Driver.runUI(app)(Data_Unit.unit)(body);
    });
}));
export {
    main
};
//# sourceMappingURL=index.js.map
